import * as React from 'react';

export interface ErrorSummaryProps {
    errorMessage?: string
}

class ErrorSummary extends React.Component<ErrorSummaryProps> {

    render ()  {
        if (!this.props.errorMessage)
            return true;
        return (
            <div className="ui red basic message">
                {this.props.errorMessage}
            </div>
        );
    }
}

export default ErrorSummary;